import type { FC } from 'react';
import React, { useCallback } from 'react';
import { Input } from '@tencent/calendar-web-component-mobile';
import style from './index.module.scss';
import classnames from 'classnames';

const { TextArea } = Input;

interface IProps {
  value?: string;
  maxLength?: number;
  className?: string;
  onChange?(value: string): void;
}

// antd-mobile统计字符长度和 tea 不一样, 在统计如👮‍♀️ 这样的emoji时会不同,统一和 tea 一样算
const TextArea2: FC<IProps> = ({ className, maxLength = Number.MAX_VALUE, onChange, ...props }) => {
  const onFieldChange = useCallback(
    (value: string) => {
      if (value.length > maxLength) {
        return;
      }
      /* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion */
      onChange!(value);
    },
    [maxLength, onChange],
  );
  return (
    <div className={classnames(style['text-area'], className)}>
      <TextArea rows={4} placeholder="请输入主办方介绍" {...props} onChange={onFieldChange} />
      <div className={style['custom-length-count']}>
        {props.value?.length}/{maxLength}
      </div>
    </div>
  );
};

export default TextArea2;
